import React from 'react';
import { isNullOrUndefined } from 'utils/Global';

export default function CheckBox(props) {
  function onClickCheckbox(e) {
    if (!isNullOrUndefined(props.onChange)) {
      props.onChange(e);
    }
  }
  if (props.isChecked) {
    return (
      <input
        data-testid="imagingschedule-checkbox-checked"
        type="checkbox"
        className="checkboxcheckmark checkboxBackgroundOrange inline"
        onChange={onClickCheckbox}
        checked={props.isChecked}
        disabled={props.disabled}
      />
    );
  }
  return (
    <input
      data-testid="imagingschedule-checkbox-unchecked"
      type="checkbox"
      className="checkboxcheckmark checkboxBackgroundWhite inline"
      onChange={onClickCheckbox}
      checked={props.isChecked}
      disabled={props.disabled}
    />
  );
}
